import axios from "axios";

import ENV from "../../util/env-config";

class Service {
  static loadCommunication(routeKey) {
    return axios.post(`${ENV.customComBase}/communication/read`, {
      key: routeKey,
    });
  }
}

export default Service;
